import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import { useCookies } from 'react-cookie';
import { Redirect } from 'react-router-dom';

function Faq({match}) {
	let history = useHistory();
	const [cookies] = useCookies(['user']);
	const user_id = cookies.user_id;
	const token = cookies.token;
	const [error1, setError] = useState(false);
	const [navtab, setNavTab] = useState();
	const [que, setQue] = useState();
  	useEffect(() => {
		getFaq();
	}, []);
	console.log(match.params);
	const navTabs = [];
	const questions = [];
	const getFaq = async () => {
		console.log(match.params.show);
		const requestOptions = {
			method: 'POST',
			headers: { 'Content-Type': 'application/json','token':token,'userId':user_id  },
			// body: JSON.stringify({dist_user_id:user_id}),
		};
		const response	 = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'get-faq', requestOptions);
		const data = await response.json();

		var show = match.params.show;
		if(show === undefined){
			show = "All";
		}
		let allTab = "nav-link";
		let allPane = "tab-pane fade";
		if(show === "All"){
			allTab = "nav-link active";
			allPane = "tab-pane active show";
		}
		navTabs.push(
			<li className="nav-item " key="all">
				<a className={allTab} data-toggle="tab" href="#All" role="tab" aria-selected="true">
					All
				</a>
			</li>
		);
		const all = [];
		for (const [i, tab] of data.tabs.entries()) {
			let restTab = "nav-link";
			let restPane = "tab-pane fade";
			console.log(show === tab);
			if(show === tab){
				restTab = "nav-link active";
				restPane = "tab-pane active show";
			}
			navTabs.push(
				<li className="nav-item" key={"nav"+i}>
					<a className={restTab} data-toggle="tab" href={"#"+tab} role="tab" aria-selected="false">
						{tab}
					</a>
				</li>
			);
			const temp = [];
			all.push(<b style={{margin:`10px`}}>{tab}</b>);
			for (const [index, value] of data.faq_questions[tab].entries()) {
				let tabPane = <div className="card" key={tab+index}>
					<div id={"u"+i+index} className="card-header bg-white shadow-none border-0">
					<h6 className="mb-0 font-weight-bold"><a  data-toggle="collapse" data-target={"#c"+i+index} aria-expanded="false" aria-controls="collapseOne" className="d-block collapsible-link py-0">{value.question}</a></h6>
					</div>
					<div id={"c"+i+index} aria-labelledby={"u"+i+index} data-parent={"#accordionExample"+tab} className="collapse">
					<div className="card-body">
						<p className="font-weight-light m-0">
							<a dangerouslySetInnerHTML={{ __html: value.answer }} />
						</p>
					</div>
					</div>
				</div>;
				temp.push(tabPane);
				tabPane = <div className="card" key={tab+index}>
					<div id={"ua"+i+index} className="card-header bg-white shadow-none border-0">
					<h6 className="mb-0 font-weight-bold"><a  data-toggle="collapse" data-target={"#ca"+i+index} aria-expanded="false" aria-controls="collapseOne" className="d-block collapsible-link py-11">{value.question}</a></h6>
					</div>
					<div id={"ca"+i+index} aria-labelledby={"ua"+i+index} data-parent="#accordionExampleall" className="collapse">
					<div className="card-body">
						<p className="font-weight-light m-0">
							<a dangerouslySetInnerHTML={{ __html: value.answer }} />
						</p>
					</div>
					</div>
				</div>;
				all.push(tabPane);
			}
			questions.push(
			<div className={restPane} id={tab} role="tabpanel" key={"wqw"+ i}>
				<div id={"accordionExample"+tab} className="accordion border-0" >
					{temp}
				</div>
			</div>
			);
		}
		questions.push(
			<div className={allPane} id="All" role="tabpanel" key="adsddjkns" style={{
				overflowY: 'scroll',
				overflowX: `hidden`,
				height: `calc(100vh - 100px)` ,
				width: `100%`}}>
				<div id="accordionExampleall" className="accordion border-0" >
					{all}
				</div>
			</div>
		);
		setQue(questions);
		setNavTab(navTabs);
		if (data.status !== "success"){
			setError(true);
		}
	};

    return (
<>
	<Helmet link={
		[{"rel": "stylesheet", "href": '/css/faq.css'}]
	}/>
	{ error1 === false && (
		<div className="row no-gutters">
			<div className="application bg-grey">
				<div className="appHeader bg-transparent text-light position-relative">
					<div className="left">
						<a className="headerButton goBack"  onClick={() => history.goBack()}>
							<img src={require("./../images/faq-icon.png").default} alt="back" className="img-fluid" />
						</a>
					</div>
					<div className="pageTitle">Frequently Asked Questions</div>
				</div>
				<div className="section full mt-0">
					<div className="wide-block border-0">
						<ul className="nav nav-tabs capsuled" role="tablist">
							{navtab}
						</ul>
						<div className="tab-content mt-2">
							{que}
						</div>
					</div>
				</div>
			</div>
			<div className="bg"></div>
		</div>
	)}
	{ error1 === true && (
        <Redirect to='/'  />
	)}
</>
    );
}

export default Faq;
